module.exports = __webpack_public_path__ + "static/media/security.7d28e459.gif";